import TableContainer from "components/Common/TableContainer";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import ModalConfirm from "components/Common/ModalConfirm";
import ModalConfirmDuplicate from "components/Common/ModalConfirmDuplicate";
import CountUp from "react-countup";
import CollapseFilter from "components/Common/CollapseFilter";
import { Link } from "react-router-dom";
import TooltipCustom from "components/Common/TooltipCustom";
import { formatDateStringToKorea, formatDateStringToUTC } from "helpers/format";
import reviewApi from "api/barReviewApi";
import { getBarReviewList } from "store/bar-review/thunk";
import LabelWrapper from "components/Common/LabelWrapper";
import DatePickerCustom from "components/Common/DatePickerCustom";
import {
  COLOR_BAR_REVIEW_TYPE,
  LIST_OPTION_BAR_REVIEW_TYPE,
} from "helpers/constans";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import { Rating } from "react-simple-star-rating";
import DropdownAsyncUsers from "components/Common/DropdownAsyncUsers";
import moment from "moment";
import noImage1 from "../../../assets/images/no-image.jpg";
import { getCommentList } from "store/winkComment/thunk";
import CommentForm from "./Comment/CommentForm";
import winkCommentApi from "api/winkCommentApi";
import NO_IMAGE from "../../../assets/images/users/ic_defaul_avatar2.png";
import SVGImageDefault from "components/Images/SVGImageDefault";
import CopyWrapper from "components/Common/CopyWrapper";

registerLocale("en", en);
registerLocale("ko", ko);

interface ModalPermissionProps {
  header?: string;
  item?: any;
  isOpen?: boolean;
  onClose?: () => void;
  winkId?: any;
  setLinkImage?: any;
}

const DEFAULT_DATA_SEARCH = {
  page: 1,
  limit: 30,
  //nickname: "",
};

const ModalComment = ({
  header,
  item,
  onClose,
  winkId,
  setLinkImage,
}: ModalPermissionProps) => {
  const { t, i18n } = useTranslation();

  const [queryReview, setQueryReview] = useState<any>(DEFAULT_DATA_SEARCH);
  const [itemToDuplicate, setItemToDuplicate] = useState<any>(false);
  const [itemToDelete, setItemToDelete] = useState<any>(false);
  const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);
  const [isOpen, setIsOpen] = useState<any>(false);

  const [nicknameSearch, setNicknameSearch] = useState<string>("");
  const [emailSearch, setEmailSearch] = useState<string>("");
  const [commentSearch, setCommentSearch] = useState<string>("");

  const [bartenderSearch, setBartenderSearch] = useState<any>({
    label: t("All Filter"),
    value: "all",
  });
  const [dateSearch, setDateSearch] = useState<any[]>([null, null]);
  const [startDate, endDate] = dateSearch;
  const [statusSearch, setStatusSearch] = useState<string>("");
  const [typeSearch, setTypeSearch] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [data, setData] = useState<any>([]);

  const [itemToEdit, setItemToEdit] = useState<any>(false);

  const handleCloseConfirmClick = () => {
    onClose && onClose();
  };

  const loadTableData = async (queryData?: any) => {
    const dataSearch = queryData ? queryData : queryReview;
    const params = {
      ...dataSearch,
      post_id: winkId,
    };

    try {
      setIsLoading(true);
      const dataRes: any = await getCommentList(params);

      if (dataRes?.data) {
        setData(dataRes?.data);
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }

    // dispatch(getTimeWorking(dataSearch));
  };

  useEffect(() => {
    if (winkId) {
      loadTableData();
    }
  }, [winkId]);

  const searchData = () => {
    loadTableData(queryReview);
  };

  const resetData = () => {
    setQueryReview(DEFAULT_DATA_SEARCH);
    setNicknameSearch((_prev) => "");
    setEmailSearch((_prev) => "");
    setCommentSearch((_prev) => "");

    setBartenderSearch({
      label: t("All Filter"),
      value: "all",
    });
    setStatusSearch("");
    setTypeSearch("");
    setDateSearch([null, null]);
    loadTableData(DEFAULT_DATA_SEARCH);
  };

  const handleChangeKeyword = (key: string, value: string) => {
    // console.log(key, value);
    setQueryReview({
      ...queryReview,
      [key]: value,
    });
  };

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t("No."),
        thWidth: 80,
        Cell: ({ ...props }) => {
          return (
            <div>
              {data?.meta?.total -
                ((data?.meta?.page - 1) * data?.meta?.limit +
                  props?.row?.index)}
            </div>
          );
        },
      },
      {
        Header: t("Type"),
        accessor: "is_seeding",
        filterable: false,
        sortable: false,
        thWidth: 140,
        thClass: "text-center whitespace-nowrap",
        Cell: (cell: any) => {
          const status = cell?.value;

          return (
            <div className="text-center" style={{ minWidth: 80 }}>
              <span
                className={`rounded-pill badge`}
                style={{
                  background: COLOR_BAR_REVIEW_TYPE[status],
                }}
              >
                {t(
                  LIST_OPTION_BAR_REVIEW_TYPE?.find(
                    (item: any) => item?.value == status
                  )?.label || ""
                )}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Images"),
        accessor: "files",
        thClass: "text-center",
        filterable: true,
        sortable: false,
        thWidth: 80,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          let data = item?.files;
          let thumbnailUrl = "";
          if (item?.files?.length > 0) {
            thumbnailUrl = item?.files?.[0];
            data = item?.files?.map((item: string) => ({ url: item }));
          }

          return thumbnailUrl ? (
            <div className="d-flex align-items-center justify-content-center">
              <div className="w-100 text-center " style={{ minWidth: "90px" }}>
                <div
                  style={{ width: "80px" }}
                  className="m-auto cursor-pointer"
                  onClick={() => {
                    let linkImage =
                      item?.files?.length > 1
                        ? { urls: data }
                        : { url: thumbnailUrl };
                    setLinkImage(linkImage);
                    document.body.className = "modal-open_img";
                  }}
                >
                  <img
                    src={thumbnailUrl}
                    className="flex-shrink-0 rounded w-100"
                    alt="thumbnail"
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null; // prevents looping
                      currentTarget.src = noImage1;
                    }}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="d-flex align-items-center justify-content-center">
              <SVGImageDefault style={{ height: "48px" }} />
            </div>
          );
        },
      },
      {
        Header: t("Comment"),
        accessor: "comment",
        filterable: true,
        sortable: false,
        Cell: (cell: any) => {
          return (
            cell?.value && (
              <div className="cursor-pointer" style={{ minWidth: 100 }}>
                <CopyWrapper contentCopy={cell?.value}>
                  {`${cell?.value}`}
                </CopyWrapper>
              </div>
            )
          );
        },
      },
      {
        Header: t("Avatar"),
        accessor: "avatar",
        thClass: "text-center",
        filterable: true,
        sortable: false,
        thWidth: 80,
        Cell: (cell: any) => {
          const avatar = cell?.row?.original?.user_profile?.profile_image_url;

          return (
            <>
              <div className="w-100 text-center " style={{ minWidth: "60px" }}>
                <div
                  style={{ width: "45px" }}
                  className="m-auto cursor-pointer"
                  onClick={() => {
                    setLinkImage({ url: avatar });
                    document.body.className = "modal-open_img";
                  }}
                >
                  <img
                    src={avatar ?? NO_IMAGE}
                    className="flex-shrink-0 rounded w-100"
                    alt="thumbnail"
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null; // prevents looping
                      currentTarget.src = NO_IMAGE;
                    }}
                  />
                </div>
              </div>
            </>
          );
        },
      },
      {
        Header: t("Email"),
        accessor: "email",
        filterable: true,
        sortable: false,
        Cell: (cell: any) => {
          const email = cell?.row?.original?.user_profile?.email;

          return (
            email && (
              <div className="cursor-pointer" style={{ minWidth: 100 }}>
                <CopyWrapper contentCopy={email}>{`${email}`}</CopyWrapper>
              </div>
            )
          );
        },
      },
      {
        Header: t("Nickname"),
        accessor: "nick_name",
        filterable: true,
        sortable: false,
        Cell: (cell: any) => {
          const nickName = cell?.row?.original?.user_profile?.nickname;

          return (
            nickName && (
              <div className="cursor-pointer" style={{ minWidth: 100 }}>
                <CopyWrapper contentCopy={nickName}>
                  {`${nickName}`}
                </CopyWrapper>
              </div>
            )
          );
        },
      },
      {
        Header: t("Created at"),
        accessor: "commented_at",
        filterable: true,
        sortable: false,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const breakEndTime = cell?.value;
          const date = formatDateStringToKorea(breakEndTime);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "120px" }}>
              {cell?.value ? (
                <span>
                  <span>{arrDate?.[0] || ""}</span> <br />{" "}
                  <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
                </span>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },
      {
        Header: t("Updated at"),
        accessor: "updated_at",
        filterable: true,
        sortable: false,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const breakEndTime = cell?.value;
          const date = formatDateStringToKorea(breakEndTime);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "120px" }}>
              {cell?.value ? (
                <span>
                  <span>{arrDate?.[0] || ""}</span> <br />{" "}
                  <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
                </span>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },
      {
        Header: t("Button Action"),
        thClass: "text-center",
        thWidth: 150,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <ul
              className="list-inline d-flex flex-wrap hstack gap-2 mb-0"
              style={{ width: "150px", justifyContent: "center" }}
            >
              <TooltipCustom
                title={t("Button Update")}
                id={`update-md-${winkId}`}
              >
                <li className="list-inline-item" id={`update-md-${winkId}`}>
                  <Link
                    className="btn btn-sm btn-soft-primary edit-item-btn"
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      setItemToEdit(item);
                    }}
                  >
                    <i className="ri-pencil-fill align-bottom "></i>
                  </Link>
                </li>
              </TooltipCustom>

              <TooltipCustom
                title={t("Button Delete")}
                id={`delete-md-${winkId}`}
              >
                <li className="list-inline-item" id={`delete-md-${winkId}`}>
                  <Link
                    className="btn btn-sm btn-soft-danger edit-item-btn"
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      setItemToDelete(item);
                    }}
                  >
                    <i className="ri-delete-bin-3-fill align-bottom"></i>
                  </Link>
                </li>
              </TooltipCustom>
            </ul>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [i18n?.language, data?.meta?.total]
  );

  const handleChangePage = useCallback((page: any) => {
    setQueryReview({ ...queryReview, page: page + 1 });
    loadTableData({ ...queryReview, page: page + 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangePicker = (values: any[] = []) => {
    setDateSearch((_prev: any) => values);
    const [startDate, endDate] = values;

    if (startDate || endDate) {
      setQueryReview({
        ...queryReview,
        start_date: startDate
          ? formatDateStringToUTC(
              moment(new Date(startDate))
                .startOf("day")
                .format("Y-MM-DD HH:mm:ss")
            )
          : "",
        end_date: endDate
          ? formatDateStringToUTC(
              moment(new Date(endDate)).endOf("day").format("Y-MM-DD HH:mm:ss")
            )
          : "",
      });
    }
  };

  const handleActionDelete = async (id: any) => {
    if (!id) {
      return;
    }
    try {
      setIsConfirmLoading((_prev) => true);
      const response: any = await winkCommentApi.deleteComment(id);

      if (response?.code === 200) {
        loadTableData();
        setIsConfirmLoading((_prev) => false);
        setItemToDelete(false);
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        setIsConfirmLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsConfirmLoading((_prev) => false);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  // End::Delete
  useEffect(() => {
    document.title = `${t("Rating & Review")} - ${t("Store List")} | Baive`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  const onCloseClick = () => {
    setItemToEdit((_prev: any) => null);
    setIsOpen(false);
  };

  const triggerRefresh = () => {
    onCloseClick();
    loadTableData();
  };

  const handleActionDuplicate = async (id: any) => {
    if (!id) {
      return;
    }

    const data = {
      bar_id: itemToDuplicate?.bar_id,
      point: itemToDuplicate?.point,
      comment: itemToDuplicate?.comment,
      reviewer_nickname: itemToDuplicate?.user_profile?.nickname,
      reviewer_email: itemToDuplicate?.user_profile?.email,
      reviewer_avatar: itemToDuplicate?.user_profile?.profile_image_url,
    };

    try {
      setIsConfirmLoading((_prev) => true);
      const response: any = await reviewApi?.postBarReview(data);
      if (response?.code == 200) {
        loadTableData();
        setIsConfirmLoading((_prev) => false);
        setItemToDuplicate(false);
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        setIsConfirmLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsConfirmLoading((_prev) => false);
      toast(`${error || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  return (
    <React.Fragment>
      <Modal
        isOpen={!!item}
        centered={true}
        size="xl"
        className="modal-fullscreen"
        toggle={handleCloseConfirmClick}
        keyboard={true}
      >
        <ModalHeader toggle={handleCloseConfirmClick}>
          {header ?? t("Comment On Wink")}
        </ModalHeader>
        <ModalBody className="">
          <div className="mt-3">
            <Container fluid>
              <Row>
                <Col lg={12}>
                  <Card
                    id="review-rating"
                    style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
                  >
                    <CardHeader className="border-0 d-flex">
                      <div className="col-sm">
                        <div>
                          <h5 className="card-title mb-0">
                            <span className="me-2">{t("Total")}:</span>
                            <CountUp
                              start={0}
                              end={data?.meta?.total || 0}
                              duration={1}
                              className="text-primary"
                            />
                          </h5>
                        </div>
                      </div>

                      <div className="col-sm-auto">
                        <button
                          type="button"
                          className="btn btn-success me-1"
                          onClick={() => setIsOpen(true)}
                        >
                          <i className="ri-add-fill align-bottom me-1"></i>{" "}
                          {t("Create Comment")}
                        </button>
                      </div>
                    </CardHeader>
                    <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                      <CollapseFilter>
                        <Row className="g-4 align-items-center mt-0 ">
                          <Col sm={12} md={3} xl={3} xxl={3} className="mt-3 ">
                            <LabelWrapper
                              label={`${t("Nickname")}`}
                              isShow={!!nicknameSearch}
                            >
                              <Input
                                type="text"
                                className="form-control search"
                                placeholder={`${t("Nickname")}...`}
                                value={nicknameSearch}
                                onChange={(e) => {
                                  setNicknameSearch(e?.target?.value);
                                  handleChangeKeyword(
                                    "nickname",
                                    e.target.value
                                  );
                                }}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    searchData();
                                  }
                                }}
                              />
                            </LabelWrapper>
                          </Col>

                          <Col sm={12} md={3} xl={3} xxl={3} className="mt-3 ">
                            <LabelWrapper
                              label={`${t("Email")}`}
                              isShow={!!emailSearch}
                            >
                              <Input
                                type="text"
                                className="form-control search"
                                placeholder={`${t("Email")}...`}
                                value={emailSearch}
                                onChange={(e) => {
                                  setEmailSearch(e?.target?.value);
                                  handleChangeKeyword("email", e.target.value);
                                }}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    searchData();
                                  }
                                }}
                              />
                            </LabelWrapper>
                          </Col>

                          <Col sm={12} md={3} xl={3} xxl={3} className="mt-3 ">
                            <LabelWrapper
                              label={`${t("Comment")}`}
                              isShow={!!commentSearch}
                            >
                              <Input
                                type="text"
                                className="form-control search"
                                placeholder={`${t("Comment")}...`}
                                value={commentSearch}
                                onChange={(e) => {
                                  setCommentSearch(e?.target?.value);
                                  handleChangeKeyword(
                                    "comment",
                                    e.target.value
                                  );
                                }}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    searchData();
                                  }
                                }}
                              />
                            </LabelWrapper>
                          </Col>

                          <Col
                            sm={12}
                            md={3}
                            xl={3}
                            xxl={3}
                            className="mt-3 mt-xl-2"
                          >
                            <LabelWrapper label={t("Users")} isShow={true}>
                              <DropdownAsyncUsers
                                name="bartender"
                                onChangeSelect={(event: any) => {
                                  setBartenderSearch(event);
                                  handleChangeKeyword(
                                    "user_id",
                                    event?.value === "all" ? "" : event?.value
                                  );
                                }}
                                isMulti={false}
                                placeholder={`${t("Select Bartender")}...`}
                                isShowIconCheck={false}
                                isAllOption={true}
                                listCheckedUsers={bartenderSearch}
                                paramsTypeUsers={1}
                                defaultParams={{ is_guest: "0", is_active: 1 }}
                                isClearable={false}
                                isShowAvatar={true}
                              />
                            </LabelWrapper>
                          </Col>

                          <Col sm={12} md={3} xl={3} xxl={3} className="mt-3 ">
                            <LabelWrapper label={t("Type")} isShow={true}>
                              <DropdownStatusNew
                                name="type"
                                dataList={LIST_OPTION_BAR_REVIEW_TYPE || []}
                                placeholder={`${t("Type")}...`}
                                className="dropdown-status-rounded"
                                classNamePrefix="name-prefix"
                                initialValue={typeSearch}
                                onChangeSelect={(event: any) => {
                                  setTypeSearch(event?.value);
                                  handleChangeKeyword(
                                    "is_seeding",
                                    event?.value
                                  );
                                }}
                                isHasOptionAll={true}
                                optionAll={{
                                  label: t("All Filter"),
                                  value: "",
                                }}
                                colors={COLOR_BAR_REVIEW_TYPE}
                              />
                            </LabelWrapper>
                          </Col>

                          <Col
                            sm={12}
                            md={3}
                            xl={3}
                            xxl={3}
                            className="mt-3  date-picker-wrapper-custom"
                          >
                            <LabelWrapper
                              label={t("Date")}
                              isShow={!!startDate || !!endDate}
                            >
                              <DatePickerCustom
                                startDate={startDate || null}
                                endDate={endDate || null}
                                onChangePicker={handleChangePicker}
                              />
                            </LabelWrapper>
                          </Col>

                          <Col
                            sm={12}
                            md={12}
                            xl={12}
                            xxl={12}
                            className="hstack gap-1 justify-content-center justify-content-md-end mt-4 "
                          >
                            <div>
                              <button
                                type="button"
                                className="btn btn-primary me-1"
                                onClick={searchData}
                              >
                                <i className="ri-search-line align-bottom me-1"></i>{" "}
                                {t("Button Search")}
                              </button>
                              <button
                                type="button"
                                className="btn btn-secondary fs-14"
                                onClick={resetData}
                              >
                                <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                                {t("Button Reset")}
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </CollapseFilter>
                    </div>
                    <CardBody className="pt-3">
                      <div>
                        <TableContainer
                          className="custom-header-css"
                          divClass="table-responsive table-card"
                          tableClass="align-middle table-bordered-dashed"
                          theadClass="table-light text-muted"
                          columns={columns}
                          data={data?.list?.length ? data?.list : []}
                          customPageSize={queryReview.limit}
                          customPageIndex={queryReview.page - 1}
                          totalRecords={data?.meta?.total}
                          customPageCount={Math.ceil(
                            Number(data?.meta?.total) /
                              Number(queryReview.limit)
                          )}
                          handleChangePage={handleChangePage}
                          manualSorting={true}
                          // sorting={{
                          //   sort_by: queryReview.sort_by,
                          //   order_by: queryReview.order_by,
                          // }}
                          // handleChangeSorting={handleChangeSorting}
                          isLoading={isLoading}
                        />
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>

            <Modal
              isOpen={!!itemToEdit?.id || isOpen}
              centered={true}
              size="xl"
              scrollable={false}
            >
              <ModalHeader toggle={onCloseClick}>
                <>
                  {!!itemToEdit?.id ? t("Update Comment") : t("Create Comment")}
                </>{" "}
                <>
                  {itemToEdit?.title &&
                    (" - " + (itemToEdit?.name || "") || "")}
                </>
              </ModalHeader>
              <ModalBody>
                <CommentForm
                  winkId={winkId}
                  triggerRefresh={triggerRefresh}
                  rowSelected={itemToEdit}
                  setLinkImage={setLinkImage}
                />
              </ModalBody>
            </Modal>

            {itemToDuplicate && (
              <ModalConfirmDuplicate
                header={t("Duplicate Comment")}
                isOpen={itemToDuplicate}
                isLoading={isConfirmLoading}
                onClose={() => setItemToDuplicate(false)}
                onConfirm={() => handleActionDuplicate(itemToDuplicate?.id)}
              />
            )}

            {itemToDelete && (
              <ModalConfirm
                header={t("Delete Comment")}
                isOpen={itemToDelete}
                isLoading={isConfirmLoading}
                onClose={() => setItemToDelete(false)}
                onConfirm={() => handleActionDelete(itemToDelete?.id)}
              />
            )}
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default ModalComment;
